import { KundeSigneringsordreDTO, SignatarDTO } from '../generated-types';

export const findActiveTasks = (signingOrder: KundeSigneringsordreDTO) =>
    (signingOrder.status === 'klar_for_signering' && !signingOrder.deadlineTidspunktPassert) ||
    (signingOrder.status === 'delvis_signert' && !signingOrder.deadlineTidspunktPassert) ||
    (!signingOrder.skalSignere && !signingOrder.deadlineTidspunktPassert && signingOrder.status === 'ferdig_signert');

export const findArchivedTasks = (signingOrder: KundeSigneringsordreDTO) =>
    (signingOrder.status === 'ferdig_signert' && (signingOrder.skalSignere || signingOrder.deadlineTidspunktPassert)) ||
    signingOrder.status === 'kansellert' ||
    signingOrder.status === 'avvist' ||
    signingOrder.status === 'utløpt' ||
    signingOrder.status === 'klar_for_kansellering' ||
    (signingOrder.status === 'klar_for_signering' && signingOrder.deadlineTidspunktPassert);

export const sortByDeadline = (signingOrderA: KundeSigneringsordreDTO, signingOrderB: KundeSigneringsordreDTO) =>
    signingOrderA.deadlineTidspunkt - signingOrderB.deadlineTidspunkt;

export const sortByLastStatus = (signingOrderA: KundeSigneringsordreDTO, signingOrderB: KundeSigneringsordreDTO) =>
    signingOrderB.statusTidspunkt - signingOrderA.statusTidspunkt;

export const getSigningUrl = (signingOrderId: number, signees: SignatarDTO[], currentUserFnr: string) => {
    let signRefUrl = '';
    const netsSignUrl = signees.filter((s) => String(s.id) === currentUserFnr)[0].signRef;
    if (netsSignUrl) {
        const refQueryParam = netsSignUrl.indexOf('sref=') === -1 ? 'ref=' : 'sref=';
        const signRef = netsSignUrl.substring(netsSignUrl.indexOf(refQueryParam) + refQueryParam.length);
        const baseUrl = netsSignUrl.substring(0, netsSignUrl.indexOf(refQueryParam));
        const behaviorParameters = 'lc=no';
        const { protocol } = window.location;
        const { host } = window.location;
        const cancelParameter = `rejectstatusurl=${protocol}%2F%2F${host}/esignering-web/cancel%3Fsignorderid%3D${signingOrderId}`;
        const exitParameter = `exit=${protocol}%2F%2F${host}/esignering-web/success%3Fsignorderid%3D${signingOrderId}`;
        // eslint-disable-next-line max-len
        const statusParameter = `status=${protocol}%2F%2F${host}/esignering-web/error%3Fsignorderid%3D${signingOrderId}%26statusid%3D`;
        signRefUrl = `${baseUrl}ref=${signRef}&${behaviorParameters}&${cancelParameter}&${exitParameter}&${statusParameter}`;
    }
    return signRefUrl;
};

function trimString(textToTrim: string) {
    return textToTrim
        .substring(0, 26)
        .replace(/^[\W_]+|[\W_]+$/g, '')
        .replace(/\//g, '_');
}
export const getDownloadSdoUrl = (signingOrderId: number, signingOrderTitle: string) => {
    const extention = '.sdo';
    const sdoFilnavn = trimString(signingOrderTitle) + extention;
    return `/esignering-web/rest/resource/signeringsordre/${signingOrderId}/sdo/${sdoFilnavn}`;
};
